import HolidayDetail from "@/Component/Module/HolidayDetail";
import NotFound from "@/Component/Module/NotFound";
import SeoHead from "@/Component/Seo/SeoHead";
import {
  serverFetchHolidayDetailsBySlug,
  serverFetchReviewsList,
} from "@/services/server";
import { isMissingHolidayDetail, renderNotFoundPage } from "@/utils/detailSlug";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { fetchPageSeo, getDataLayerAuth } from "@/utils/pageSeo";

export default function Page({
  showNotFound,
  seo,
  seoCountry,
  packageSlug,
  initialPackageDetail,
  initialReviewsList,
}) {
  if (showNotFound) {
    return (
      <>
        <SeoHead fallbackTitle="Page not found | Next Holidays" noIndex />
        <NotFound />
      </>
    );
  }

  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Holiday Packages | Next Holidays"
      />
      <HolidayDetail
        packageSlug={packageSlug}
        initialPackageDetail={initialPackageDetail}
        initialReviewsList={initialReviewsList}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const slug = context.params?.slug;
  const packageSlug = Array.isArray(slug) ? slug[0] : slug;

  if (!packageSlug) {
    return renderNotFoundPage(context);
  }

  try {
    const country = getCountryFromContext(context);
    const [response, reviewsResponse] = await Promise.all([
      serverFetchHolidayDetailsBySlug(packageSlug, country),
      serverFetchReviewsList(
        { moduleType: "Holiday", slug: packageSlug },
        country
      ).catch(() => null),
    ]);
    if (isMissingHolidayDetail(response)) {
      return renderNotFoundPage(context);
    }

    const seoResult = await fetchPageSeo(context, {
      dataLayerPayload: {
        module: "holiday",
        events: "view_item",
        slug: packageSlug,
        ...getDataLayerAuth(context),
      },
    });
    if (seoResult.redirect) return seoResult;

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        packageSlug,
        initialPackageDetail: response?.data || response || null,
        initialReviewsList: reviewsResponse?.data || reviewsResponse || null,
      },
    };
  } catch {
    return renderNotFoundPage(context);
  }
}
